<template>
  <div 
    class="xit-fb-template node component-list" 
    :class="[node.name]" 
  > 
    <div class="card-body-handler card_data_body p-0">

      <div class="card-sockets card-sockets-custom">
        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>

      <div class="card-data">
        <ul class="list-group list-group-component">
          <li 
            :key="index"
            class="list-group-item"
            v-for="(input, index) in node.compatibleInputs"
            @click.stop="handleClickOnList(node, $event)"
            :data-input-socket-name="input" 
            :data-component-name="getComponentName(input).name">

            <i :class="getComponentName(input).iconClass"
              @click.stop="handleClickOnList(node, $event)"
              :data-input-socket-name="input" 
              :data-component-name="getComponentName(input).name">              
            </i>

            <span
              @click.stop="handleClickOnList(node, $event)"
              :data-input-socket-name="input" 
              :data-component-name="getComponentName(input).name">
              {{ getComponentName(input).lingualName }}
            </span>
            
          </li>
          
          <li @click.stop="handleClickOnList(node, $event)" class="list-group-item bg-light"><i class="fas fa-times-circle text-danger"></i><span class="text-danger">{{utils_button_cancel}}</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { lang } from '../../assets/lang'
import { App } from '../../App'
import { socketToComponent } from '../../data'
import { 
  templateComponentMethods, 
  createNodeOnClickComponentList 
} from '../../utils/functions'

export default {
  name: 'ComponentListTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },
  data: () => ({
    utils_button_cancel: lang.utils_button_cancel
  }),

  methods: {
    ...templateComponentMethods,

    async handleClickOnList(node, event) {
      if ((! event.target.dataset.componentName) || (! event.target.dataset.inputSocketName)) {
        App.editor.removeNode(node)
        return;
      }

      const output = node.output.node.outputs.get(node.output.key)

      if (output.connections.length > 0) {
        output.connections.forEach(c => App.editor.removeConnection(c))
      }

      // Stop adding new node when multiple connections are not allowed
      if (output.connections.length > 0 && (false === output.multipleConnections)) {
        App.editor.removeNode(node)
        return;
      }
      
      return await createNodeOnClickComponentList(node, event)
    },

    getComponentName(input) {
      return socketToComponent[input]
    }
  }
}
</script>